import { render, staticRenderFns } from "./RequestIT2104Modal.vue?vue&type=template&id=acc0fa8c&scoped=true&"
import script from "./RequestIT2104Modal.vue?vue&type=script&lang=ts&"
export * from "./RequestIT2104Modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc0fa8c",
  null
  
)

export default component.exports